import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './AccordionItem.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_Icon } from 'ui/components/1-atoms/Media/Icon/Icon';
import { generateId } from 'helpers/id';
import { UI_RichText } from 'ui/components/1-atoms/RichText/RichText';
import IconPlus from 'ui/icons/icon_plus.svg';
import IconMinus from 'ui/icons/icon_minus.svg';

export interface UI_AccordionItemProps {
	className?: string;
	heading: string;
	text: string;
	borderBotLg?: boolean;
	last?: boolean;
}

export const UI_AccordionItem: React.FC<UI_AccordionItemProps> = ({ className, heading, text, borderBotLg = false, last = false }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [id, setId] = useState('');

	useEffect(() => {
		const id = generateId();

		setId(id);
	}, []);

	return (
		<div className={classNames(styles.AccordionItem, className)}>
			<UI_Heading
				headingLevel="h3"
				className={classNames(
					styles.AccordionItem_heading,
					{ [styles['AccordionItem_heading--bottomBorder']]: !isOpen && last && !borderBotLg },
					{ [styles['AccordionItem_heading--bottomBorderMd']]: !isOpen && last && borderBotLg },
				)}
			>
				<button
					onClick={() => setIsOpen(!isOpen)}
					className={styles.AccordionItem_trigger}
					aria-expanded={isOpen}
					aria-controls={`panel-${id}`}
					id={`trigger-${id}`}
				>
					<UI_Icon size="md">{isOpen ? <IconMinus /> : <IconPlus />}</UI_Icon>
					{heading}
				</button>
			</UI_Heading>

			<div
				id={`panel-${id}`}
				role="region"
				aria-labelledby={`trigger-${id}`}
				className={classNames(
					styles.AccordionItem_content,
					{ [styles['AccordionItem_content--bottomBorder']]: isOpen && last && !borderBotLg },
					{ [styles['AccordionItem_heading--bottomBorderMd']]: isOpen && last && borderBotLg },
				)}
				hidden={!isOpen}
			>
				<UI_RichText content={text} className={styles.AccordionItem_text} />
			</div>
		</div>
	);
};
